import { cn } from '../../utils/cn';
import { Skeleton } from '../ui/Skeleton';
import pt from '../../locales/pt';

const VARIANTS = {
  hero: {
    className: 'flex min-h-[14rem] flex-col gap-3 rounded-2xl border border-border bg-card p-5',
    children: (
      <>
        <Skeleton className="h-6 w-40 rounded-full" />
        <Skeleton className="h-4 w-48" />
        <Skeleton className="h-12 w-32" />
        <Skeleton className="h-2.5 w-full rounded-full" />
      </>
    ),
  },
  list: {
    className: 'flex flex-col gap-3',
    children: (
      <>
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className="flex items-center gap-3 rounded-xl border border-border bg-card p-4"
          >
            <Skeleton className="h-10 w-10 shrink-0 rounded-full" />
            <div className="flex flex-1 flex-col gap-2">
              <Skeleton className="h-4 w-3/5" />
              <Skeleton className="h-3 w-2/5" />
            </div>
            <Skeleton className="h-5 w-16" />
          </div>
        ))}
      </>
    ),
  },
  'card-grid': {
    className: 'grid gap-4 sm:grid-cols-2 lg:grid-cols-3',
    children: (
      <>
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className="flex flex-col gap-3 rounded-2xl border border-border bg-card p-5"
          >
            <Skeleton className="h-5 w-24" />
            <Skeleton className="h-8 w-20" />
            <Skeleton className="h-2.5 w-full rounded-full" />
          </div>
        ))}
      </>
    ),
  },
};

export function SectionSkeleton({
  variant = 'list',
  className,
  label = pt.common.loading,
}) {
  const config = VARIANTS[variant] ?? VARIANTS.list;

  return (
    <div
      className={cn(config.className, className)}
      aria-busy="true"
      aria-label={label}
    >
      {config.children}
    </div>
  );
}
